import { useEffect } from "react";

import type { PaymentYearSelection } from "../components/payment-statement/PaymentYearFilter";

/**
 * 選択中の年にデータが無いとき、available_years の最新年へ自動切り替える。
 * 「すべて」選択中はそのまま維持する。
 */
export const useAutoSelectPaymentYear = (
  availableYears: number[],
  selectedYear: PaymentYearSelection,
  setSelectedYear: (_year: PaymentYearSelection) => void,
): void => {
  useEffect(() => {
    if (availableYears.length === 0) return;
    if (selectedYear === "all") return;
    if (!availableYears.includes(selectedYear)) {
      setSelectedYear(availableYears[0]);
    }
  }, [availableYears, selectedYear, setSelectedYear]);
};
